import { Formik } from 'formik';

const EditTemplate = ({ handleClose }) => {
  return (
    <Formik>
      <form>
        <div id="EditPopup">
          <div className="popup-backdrop ">
            <div className="popup-content slide-in">
              {/* Popup Header */}
              <div className="popup-header">
                <h4 className="popup-title">Test Template</h4>
                <button className="custom-btn-close" onClick={handleClose}></button>
              </div>

              {/* Popup Body */}
              <div className="popup-body">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="editTemplateHdr">
                      <div
                        className="btn-group me-3"
                        role="group"
                        aria-label="Basic radio toggle button group"
                      >
                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio"
                          id="btnradio1"
                          autocomplete="off"
                          checked
                        />
                        <label className="btn btn-outline-primary" htmlFor="btnradio1">
                          <img src="../assets/images/pc.svg" alt="" className="me-1" width="18px" />
                          Desktop
                        </label>

                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio"
                          id="btnradio2"
                          autocomplete="off"
                        />
                        <label className="btn btn-outline-primary" htmlFor="btnradio2">
                          <img
                            src="../assets/images/mobile.svg"
                            alt=""
                            className="me-1"
                            width="18px"
                          />
                          Mobile
                        </label>
                      </div>
                      <div className="flDiv">
                        <button className="btn btnTxt btnImg">
                          <img
                            src="../assets/images/edit-pencil.svg"
                            alt=""
                            className="me-1"
                            width="18px"
                          />
                          Edit
                        </button>
                        <button className="btn btnTxt btnImg">
                          <img
                            src="../assets/images/clone.svg"
                            alt=""
                            className="me-1"
                            width="18px"
                          />
                          Clone
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="tempView">
                      <img src="../assets/images/tempView.jpg" alt="" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Popup Footer */}
              <div className="popup-footer">
                <button type="button" className="cancel-lead ld-btn" onClick={handleClose}>
                  Cancel
                </button>
                <button type="button" className="save-lead ld-btn">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Formik>
  );
};
export default EditTemplate;
